// App color theme (light/dark). The actual <html class="dark"> is applied
// before paint by an inline script in index.html (no flash); this composable
// keeps a reactive mirror + lets the UI toggle/persist it.
import { ref } from 'vue';

type Theme = 'light' | 'dark';
const KEY = 'lymon-theme';

// Module-level singleton state, seeded from whatever the boot script applied.
const theme = ref<Theme>(
  typeof document !== 'undefined' && document.documentElement.classList.contains('dark')
    ? 'dark'
    : 'light',
);

function apply(t: Theme): void {
  document.documentElement.classList.toggle('dark', t === 'dark');
}

export function useTheme() {
  function setTheme(t: Theme): void {
    theme.value = t;
    try {
      localStorage.setItem(KEY, t);
    } catch {
      /* private mode / storage disabled — non-fatal */
    }
    apply(t);
  }
  function toggle(): void {
    setTheme(theme.value === 'dark' ? 'light' : 'dark');
  }
  return { theme, setTheme, toggle };
}
